<script lang="ts">
	import { format } from 'svelte-i18n';

	import { Alert, Container } from '@Shelly/shelly-design-system';
	import SelectList from 'src/components/SelectList/SelectList.svelte';

	export let editGroup;

	const groupTypes = ['light', 'relay', 'roller', 'thermostat'];

	$: groupTypesData = [
		{
			icon: 'fal fa-lightbulb',
			name: $format(`device_type_${groupTypes[0]}`),
			type: groupTypes[0],
			selected: editGroup.type === groupTypes[0],
			disabled: typeof editGroup.id !== 'undefined',
		},
		{
			icon: 'fal fa-outlet',
			name: $format(`device_type_${groupTypes[1]}`),
			type: groupTypes[1],
			selected: editGroup.type === groupTypes[1],
			disabled: typeof editGroup.id !== 'undefined',
		},
		{
			icon: 'fal fa-blinds',
			name: $format(`device_type_${groupTypes[2]}`),
			type: groupTypes[2],
			selected: editGroup.type === groupTypes[2],
			disabled: typeof editGroup.id !== 'undefined',
		},
		{
			icon: 'fal fa-thermometer-three-quarters',
			name: $format(`device_type_${groupTypes[3]}`),
			type: groupTypes[3],
			selected: editGroup.type === groupTypes[3],
			disabled: typeof editGroup.id !== 'undefined',
		},
	];

	const onSelectType = (groupType: string) => {
		editGroup.type = groupType;
	};
</script>

<Container noScroll padding="0">
	{#if typeof editGroup.id !== 'undefined'}
		<Alert
			class="mb-s"
			type="info"
			heading={$format('info_group_type_change', {
				default: 'You cannot change the Type of an already saved group',
			})}
		/>
	{/if}

	<SelectList
		title={$format('label_select_type', {
			default: 'Select type',
		})}
		description={$format('info_group_devices', {
			default: 'You can only group together devices with similar functionality.',
		})}
		list={groupTypesData}
		variant="radio"
		withSearch={false}
		selectCardClass="text-capitalize"
		on:click={(e) => onSelectType(e.detail.type)}
	/>
</Container>
